import './LoadingProgressBar.css';
import finishFlagIcon from '../progress_bar_icon_finish.png';
import progressIcon from '../icon.png';

/** Figma loading_background (195:1556) — 172.281 1618.788 735.4375×102.571 */
const BAR_LEFT = 172.28125762939453;
const BAR_TOP = 1618.7880859375;
const BAR_WIDTH = 735.4375;
const BAR_HEIGHT = 102.5714111328125;

/** Figma icon (195:1564) — 44.369 1572.590 180.734×209.041 */
const ICON_LEFT = 44.36896371841431;
const ICON_TOP = 1572.5900446706364;
const ICON_WIDTH = 180.73376712583558;
const ICON_HEIGHT = 209.04105957095817;

/** Figma progress_bar_icon_finish (195:1558) — 881.846 1572.590 159.183×195.141 */
const FLAG_LEFT = 881.8456802368164;
const FLAG_TOP = 1572.58984375;
const FLAG_WIDTH = 159.18292236328125;
const FLAG_HEIGHT = 195.14112854003906;

/** Figma timer_text (195:1563) — 494.996 1638.198 90×66 */
const PERCENT_LEFT = 494.99610137939453;
const PERCENT_TOP = 1638.1982421875;
const PERCENT_WIDTH = 90;
const PERCENT_HEIGHT = 66;

export type LoadingProgressBarProps = {
  /** Progress 0–1. */
  value?: number;
};

/** Figma loading HUD — track + fill + icons + percent (195:1593). */
export function LoadingProgressBar({ value = 0 }: LoadingProgressBarProps) {
  const progress = Math.max(0, Math.min(1, value));
  const fillWidth = progress * BAR_WIDTH;
  const percent = Math.round(progress * 100);

  return (
    <>
      <div
        className="loading-progress-bar__bar"
        style={{
          left: BAR_LEFT,
          top: BAR_TOP,
          width: BAR_WIDTH,
          height: BAR_HEIGHT,
        }}
        role="progressbar"
        aria-label="Загрузка"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
      >
        <div className="loading-progress-bar__track">
          <div className="loading-progress-bar__track-fill" />
          <div className="loading-progress-bar__track-shade" />
        </div>
        {fillWidth > 0 ? (
          <div className="loading-progress-bar__fill" style={{ width: fillWidth }}>
            <div className="loading-progress-bar__fill-color" />
            <div className="loading-progress-bar__fill-shade" />
          </div>
        ) : null}
      </div>

      <img
        className="loading-progress-bar__icon"
        src={progressIcon}
        alt=""
        draggable={false}
        aria-hidden
        style={{
          left: ICON_LEFT,
          top: ICON_TOP,
          width: ICON_WIDTH,
          height: ICON_HEIGHT,
        }}
      />
      <div
        className="loading-progress-bar__percent"
        style={{
          left: PERCENT_LEFT,
          top: PERCENT_TOP,
          width: PERCENT_WIDTH,
          height: PERCENT_HEIGHT,
        }}
        aria-hidden
      >
        {`${percent}%`}
      </div>
      <img
        className="loading-progress-bar__flag"
        src={finishFlagIcon}
        alt=""
        draggable={false}
        aria-hidden
        style={{
          left: FLAG_LEFT,
          top: FLAG_TOP,
          width: FLAG_WIDTH,
          height: FLAG_HEIGHT,
        }}
      />
    </>
  );
}
